import { request } from '~/services/request'

/**
 * 获取 自定义 页面 详情
 * @param {*} handle
 */
export const getPagesDetailAPI = async (handle: any) => {
  return request.get<{
    data: API.CustomTemplate
  }>(`/pages/${handle}`)
}
